module.exports = __webpack_public_path__ + "static/teamwork-screen-image-3b40d7c8c3a79fcef2d0407f0e56527b.png";